import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { FieldType } from '@ngx-formly/core';
import { concat, of, Subject, Subscription } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, filter, startWith, switchMap, takeUntil, tap } from 'rxjs/operators';
import { EmployeeProfile, UserApi } from 'src/app/core/api.gen';
import { DataPopulationEvents, ImmigrationDataPopulationService } from 'src/app/immigration/services/data-population/ImmigrationDataPopulation.service';
import { isNullOrUndefined } from '../../../app/core/utils';

@Component({
  selector: 'eos-employee-select',
  template: `
  <ng-select [items]="options$ | async" (change)="loadEmpDetails($event)"
      [notFoundText]="to.notFoundText"
      [placeholder]="to.placeholder"
      [typeahead]="searchInput$"
      bindLabel="fullName"
      bindValue="email"
      [loading]="showLoader"
      [formControl]="formControl">
      <ng-template ng-option-tmp let-item="item" let-search="searchTerm">       
        <div class="d-flex justify-content-between">
          <span>{{item.fullName}}</span>
          <a *ngIf="item.officeLocationCountry.id !== null" [routerLink]="getUrl(item)" target="_blank">
            <img src="design/images/chevron-right.png"/>
          </a>
        </div>
        <div><span><small>{{item.email}}</small></span> <span><small>  GPN : {{item.gpn}}</small></span>  <span><small> GUI : {{item.gui}}</small></span> </div>
      </ng-template>
    </ng-select>
    <div class="employee-selectPopup" *ngIf="isEmployeeSelected">
         <div style="margin-left:5px;margin-right:5px">The employee's details have been auto-populated from the TMT employee profile, please review and validate before submission </div>
     </div>
  `,
})
export class EmployeeProfileSelectComponent extends FieldType implements OnDestroy {
  onDestroy$ = new Subject<void>();
  searchInput$ = new Subject<string>();
  gpnGuiUpdatedSub:Subscription;
  options$;
  showLoader = false;
  operations: string[];
  isEmployeeSelected = false;

  constructor(private userService: UserApi,
    private router: Router,
    private ImmigrationDataPopulation: ImmigrationDataPopulationService) {
    super();
  }

  getUrl(item: EmployeeProfile) {
    if (item.officeLocationCountry && item.officeLocationCountry.value !== null) {
      return `/immigration/profile/search/${item.officeLocationCountry.value}/${item.gpn}/${item.gui}`
    } else {
      return '#'
    }
  }

  ngOnInit() {
    this.gpnGuiUpdatedSub = this.ImmigrationDataPopulation.GpnGuiUpdated.subscribe(val=>{
         if(val === true){
        this.formControl.reset();
      }
    });
    this.options$ = concat(
      of([]),
      this.searchInput$.pipe(
        takeUntil(this.onDestroy$),
        startWith(''),
        filter(v => v !== null && v.length > 2),
        debounceTime(500),
        distinctUntilChanged(),
        tap(() => this.showLoader = true),
        switchMap(term => this.userService.getEmployeesByFilter(term).pipe(
          catchError(() => of([])),
          tap(() => {
            this.showLoader = false;

          })
        ))
      )
    );
  }
  loadEmpDetails(x:EmployeeProfile) {

    this.operations = [];
    this.operations = this.to.onSelect();
    this.emitOperations(!isNullOrUndefined(x));

  }
  emitOperations(employeeSelected) {
    if (this.operations.includes(DataPopulationEvents.GpnGuiSearch)) {
      this.ImmigrationDataPopulation.EmployeeUpdated.next(employeeSelected);
      if (employeeSelected) {
        this.isEmployeeSelected = true;
      }
      else { this.isEmployeeSelected = false;}
    }
  }

  ngOnDestroy() {
    this.onDestroy$.complete();
    if(this.gpnGuiUpdatedSub)
      this.gpnGuiUpdatedSub.unsubscribe();
    
  }
}
